var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wide"},[_c('div',{class:[`button-inside-${_vm.color}`, 'fix-all']},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }